/* eslint-disable prefer-object-spread */
import { createReducer } from 'reduxsauce';
import Types from '../Actions/Types';

export const INITIAL_STATE = {
	fetchingCommoditiesChartData: false,
	data: {}
};

const requestCommoditiesChart = state => {
	return Object.assign({}, state, {
		fetchingCommoditiesChartData: true
	});
};

const receiveCommoditiesChart = (state, action) => {
	return Object.assign({}, state, {
		fetchingCommoditiesChartData: false,
		data: Object.assign({}, action.response.data)
	});
};

/**
 * Called by the saga in the finally block to ensure that in all cases the
 * fetching state for the call is set back to false to avoid infinite loader
 * and the ability to display both loaders and "sorry no data" messages.
 * @param {object} state
 * @param {object} action
 */
const handleLoader = (state, action) => {
	return Object.assign({}, state, {
		[action.fetchName]: false
	});
};

// map our types to our handlers
const ACTION_HANDLERS = {
	[Types.API_CIBC_REQUEST_COMMODITIESCHART]: requestCommoditiesChart,
	[Types.API_CIBC_RECEIVE_COMMODITIESCHART]: receiveCommoditiesChart,
	[Types.API_CIBC_HANDLE_COMMODITIESCHART_LOADER]: handleLoader
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
